import { client } from "../../amplify-client";
import { getEventApiHttpUrl } from "../config/event-api-config-service";

async function runLifecycleMutation(action, chatId) {
  const mutation = client?.mutations?.manageChatLifecycle;
  if (typeof mutation !== "function") {
    throw new Error("manageChatLifecycle mutation is unavailable. Deploy updated backend schema.");
  }

  const eventApiHttpUrl = getEventApiHttpUrl();
  const resp = await mutation({
    action,
    chatId,
    ...(eventApiHttpUrl ? { eventApiHttpUrl } : {}),
  });
  if (resp?.errors?.length) {
    throw new Error(resp.errors.map((e) => e.message).join(", "));
  }

  const success = resp?.data?.success;
  if (success === false) {
    throw new Error(resp?.data?.message || "Lifecycle mutation failed");
  }

  return resp?.data ?? { success: true, action, chatId };
}

export async function acceptChatLifecycle(chatId) {
  await runLifecycleMutation("accept", chatId);
}

export async function denyChatLifecycle(chatId) {
  await runLifecycleMutation("deny", chatId);
}

export async function deleteChatLifecycle(chatId) {
  await runLifecycleMutation("delete", chatId);
}
